import { Tuple } from "components/Shared/Interfaces"
import { EMPTY_STRING } from "constants/constants"
import { RequestParameters } from "components/Shared/Filters/interfaces"

export type Level = keyof RequestParameters

export enum FILTER_VALID {
	FINELINE = "fineline",
	SUBCATEGORIES = "subcategories",
	CATEGORIES = "categories",
	DEPARTMENTS = "departments",
	VENDORS = "vendors",
}

export enum TYPE_SELECT {
	UNIQUE = "singular",
	FEW = "few",
	ALL = "all",
}

export enum GENDER {
	MALE = "male",
	FEMALE = "female",
}

const FILTER_GENDERS = [
	{ filter: FILTER_VALID.FINELINE, gender: GENDER.MALE },
	{ filter: FILTER_VALID.SUBCATEGORIES, gender: GENDER.FEMALE },
	{ filter: FILTER_VALID.CATEGORIES, gender: GENDER.FEMALE },
	{ filter: FILTER_VALID.DEPARTMENTS, gender: GENDER.MALE },
	{ filter: FILTER_VALID.VENDORS, gender: GENDER.MALE },
]

export const getGenderFilter = (filter: string): string | undefined => {
	const filterGender = FILTER_GENDERS.find((item) => item.filter === filter)
	return filterGender ? filterGender.gender : GENDER.MALE
}

export const EXCLUDE_FILTER = []

export const FILTER_ORDER_CONFIG: Level[] = [
	FILTER_VALID.FINELINE,
	FILTER_VALID.SUBCATEGORIES,
	FILTER_VALID.CATEGORIES,
	FILTER_VALID.DEPARTMENTS,
	FILTER_VALID.VENDORS,
]

export enum ADJUST_LEVEL {
	previous = -1,
	current = 0,
	next = 1,
}

export type filterInfoType = {
	currentLevel: string
	nextLevel: string
	previousLevel: string
	values: Tuple[]
	isMultiSelect: boolean
	geTypeSelect: TYPE_SELECT
	getSelectValueByIndex(index: number): string
}
export const DEFAULT_FILTER = FILTER_VALID.DEPARTMENTS

export const EMPTY_FILTER_INFO = (DEFAULT_FILTER: string): filterInfoType => {
	return {
		currentLevel: DEFAULT_FILTER,
		nextLevel: EMPTY_STRING,
		previousLevel: EMPTY_STRING,
		values: [{ code: EMPTY_STRING, name: EMPTY_STRING }],
		isMultiSelect: true,
		geTypeSelect: TYPE_SELECT.ALL,
		getSelectValueByIndex: () => {
			return EMPTY_STRING
		},
	}
}
